<script lang="ts">
  import { fade } from 'svelte/transition';
  import { impression, trackEvent } from '../../../util/snowplow';
  import Favourite from '../../Favourite.svelte';
  import { type Promo } from './SKPromos';

  const utmParams =
    '?utm_source=deltanrkno&utm_medium=delta&utm_campaign=stjernekamp';

  export let promo: Promo;
</script>

<li>
  <div class="content-wrapper" in:fade={{ delay: 0, duration: 250 }} out:fade>
    <a
      href={`${promo.href}${utmParams}`}
      on:click={() =>
        trackEvent({ action: 'click:promo', label: promo.contentId })}
      target="_blank"
      referrerpolicy="no-referrer"
      use:impression={promo.contentId}
    >
      <img aria-hidden src={promo.img} alt={promo.description} />
      {#if promo.logo}
        <div class="logo" aria-label={promo.logo.alt}>
          <!-- eslint-disable-next-line svelte/no-at-html-tags -->
          {@html promo.logo.html}
        </div>
      {/if}
      <h3>{promo.title}</h3>
      {#if promo.description}
        <p>«{promo.description}»</p>
      {/if}
    </a>
    {#if promo.favouriteContentType !== ''}
      <Favourite
        sourceMedium={promo.sourceMedium}
        favouriteContentType={promo.favouriteContentType}
        contentId={promo.contentId}
      />
    {/if}
  </div>
</li>

<style>
  li {
    display: grid;
  }
  .content-wrapper {
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 1;
    grid-row-end: 2;
  }
  li {
    max-width: 30rem;
    position: relative;
    margin: 1rem 0.5rem;
    border-radius: 3px;
    overflow: hidden;
    padding: 0 1rem 1rem 1rem;
    background-color: var(--sk-dark-blue);
    color: white;
  }

  a {
    box-shadow: none;
    text-align: left;
  }

  h3 {
    font-size: 2rem;
    font-weight: 700;
  }

  img {
    min-height: 10rem;
    width: calc(100% + 2rem);
    margin: 0 -1rem;
  }

  .logo {
    margin: 1.25rem 0 0.75rem 0;
    font-size: 0.875rem;
  }
</style>
